import React from "react";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";

import CandidatePageFooter from "candidate/CandidatePageFooter";
import { ContainedButton } from "common/DS/Buttons";
import { CardLevelOne } from "common/DS/ElevatedCard";
import { ChevronLeftIcon } from "common/DS/Icons";
import ReactionPicker from "common/DS/ReactionPicker";
import { H6 } from "common/DS/Text";
import { Reaction } from "workstep/pages/Feedback/Comments/state/types";

type Props = {
    subject: string;
    body: string;
    checkinUrl: Maybe<string>;
    onReact?: (reaction: Maybe<Reaction>) => void;
    reactionLoading?: boolean;
    reaction?: Maybe<Reaction>;
    enableReactions?: boolean;
};

export default function MessageCard({
    subject,
    body,
    checkinUrl,
    onReact = () => undefined,
    reactionLoading = false,
    reaction,
    enableReactions = false,
}: Props) {
    let checkinLinkProps: { onClick?: () => void; href?: string } | undefined;
    if (checkinUrl === "#") {
        checkinLinkProps = { onClick: () => undefined };
    } else if (checkinUrl) {
        checkinLinkProps = { href: checkinUrl };
    }

    return (
        <>
            <Stack spacing={3} sx={{ maxWidth: 600, mx: "auto", py: 3, px: 2 }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <IconButton
                        component="a"
                        href="/hub"
                        aria-label="Back to hub"
                        sx={{ p: 0, color: "inherit" }}
                    >
                        <ChevronLeftIcon sx={{ fontSize: 48 }} />
                    </IconButton>
                    <H6>{subject}</H6>
                </Stack>
                <CardLevelOne style={{ padding: 24 }}>
                    <div
                        className="inform-message-card__body"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: body }}
                    />
                    {checkinLinkProps && (
                        <Stack alignItems="center" sx={{ mt: 2 }}>
                            <ContainedButton {...checkinLinkProps}>
                                Take me to the survey
                            </ContainedButton>
                        </Stack>
                    )}
                </CardLevelOne>
                {enableReactions && (
                    <Stack alignItems="center">
                        <ReactionPicker
                            onChange={onReact}
                            disabled={reactionLoading}
                            reaction={reaction}
                        />
                    </Stack>
                )}
            </Stack>
            <CandidatePageFooter />
        </>
    );
}
